import { FC, useEffect, useState } from "react";
import Prompt from "@/models/prompt/prompt";
import PromptCardSkeleton from "../components/PromptCardSkeleton";
import PromptCard from "../components/PromptCard";
import ReviewPromptDialog from "../components/ReviewPromptDialog";
import { User } from "@/models/users/User";

const AcceptedPrompts: FC<{
  search: string;
  loading: boolean;
  prompts: Prompt[];
  tenantUsers: User[];
  handleSearchChange: (search: string) => void;
}> = ({ search, loading, prompts, tenantUsers, handleSearchChange }) => {
  const [selectedPrompt, setSelectedPrompt] = useState<Prompt | undefined>();
  const [isReviewingAcceptedPrompt, setIsReviewingAcceptedPrompt] =
    useState(false);

  const handleViewAcceptedPrompt = (prompt: Prompt) => {
    setSelectedPrompt(prompt);
    setIsReviewingAcceptedPrompt(true);
  };

  const handleCloseDialog = () => {
    setIsReviewingAcceptedPrompt(false);
    setSelectedPrompt(undefined);
  };

  useEffect(() => {
    handleSearchChange(search);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <div className="flex flex-col h-full">
      {loading ? (
        <div className="h-full overflow-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pb-2 pt-2">
            {Array.from({ length: 6 }).map((_, index) => (
              <PromptCardSkeleton key={index} />
            ))}
          </div>
        </div>
      ) : prompts.length === 0 ? (
        <div className="h-full flex flex-col items-center justify-center text-xl text-muted-foreground flex-1">
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            Ingen accepterede prompts
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pb-2 pt-2">
          {prompts.map((prompt) => (
            <PromptCard
              key={prompt.id}
              prompt={prompt}
              user={tenantUsers.find((u) => u.id === prompt.userId)}
              onClick={() => handleViewAcceptedPrompt(prompt)}
            />
          ))}
        </div>
      )}
      {selectedPrompt && (
        <ReviewPromptDialog
          prompt={prompts.find((p) => p.id === selectedPrompt.id) as Prompt}
          isOpen={isReviewingAcceptedPrompt}
          onOpenChange={handleCloseDialog}
        />
      )}
    </div>
  );
};

export default AcceptedPrompts;
